<div class="add-user-wrapper" *ngIf="!loading">
  <!-- Top Header Bar -->
  <div class="top-header-bar">
    <button class="btn-back" (click)="onCancelClick()">
      <i class="material-icons">arrow_back</i>
      Back
    </button>
    <h1 class="page-main-title">
      <img src="/assets/images/edit user.svg" style="margin-right: 5px;" />
      User Management
    </h1>
  </div>

  <!-- Main Content Container -->
  <div class="add-user-content">
    <div class="add-user-card">
      <!-- Card Yellow Header -->
      <div class="card-header-yellow">
        <span class="material-icons header-icon">storefront</span>
        <span class="header-text">{{ user.id > 0 ? "Edit User Details & Role" : "Add New User" }}</span>
      </div>

      <!-- Card Form Body -->
      <div class="card-body-content">
        <form [formGroup]="addEditUserForm">
          <div class="row">
            <!-- First Name -->
            <div class="col-md-6 form-group-col">
              <label class="field-label">
                First Name
                <span matTooltip="Enter first name" style="
                    background-image: url('/assets/images/Vector.svg');
                    background-repeat: no-repeat;
                    background-size: auto;
                    background-position: center;
                    padding: 10px;
                  "></span>
              </label>
              <input type="text" formControlName="name" class="custom-form-input" placeholder="Enter First Name" />
              <div class="text-danger mt-1" *ngIf="
                  addEditUserForm.get('name').touched &&
                  addEditUserForm.get('name').hasError('required')
                " style="font-size: 12px;">
                First Name is required
              </div>
            </div>

            <!-- Last Name -->
            <div class="col-md-6 form-group-col">
              <label class="field-label">
                Last Name
                <span matTooltip="Enter last name" style="
                    background-image: url('/assets/images/Vector.svg');
                    background-repeat: no-repeat;
                    background-size: auto;
                    background-position: center;
                    padding: 10px;
                  "></span>
              </label>
              <input type="text" formControlName="lastName" class="custom-form-input" placeholder="Enter Last Name" />
              <div class="text-danger mt-1" *ngIf="
                  addEditUserForm.get('lastName').touched &&
                  addEditUserForm.get('lastName').hasError('required')
                " style="font-size: 12px;">
                Last Name is required
              </div>
            </div>

            <!-- Email -->
            <div class="col-md-6 form-group-col">
              <label class="field-label">
                Email
                <span matTooltip="Enter email address" style="
                    background-image: url('/assets/images/Vector.svg');
                    background-repeat: no-repeat;
                    background-size: auto;
                    background-position: center;
                    padding: 10px;
                  "></span>
              </label>
              <div class="custom-input-with-icon">
                <input type="email" formControlName="email" class="custom-form-input" placeholder="Enter Email" />
                <span class="input-icon-right">
                  <mat-icon class="mail-icon">mail_outline</mat-icon>
                </span>
              </div>
              <div class="text-danger mt-1" *ngIf="
                  addEditUserForm.get('email').touched &&
                  addEditUserForm.get('email').hasError('required')
                " style="font-size: 12px;">
                Email is required
              </div>
              <div class="text-danger mt-1" *ngIf="!isEmailAllowed">
                This email is taken, try another
              </div>
            </div>

            <!-- Market -->
            <div class="col-md-6 form-group-col">
              <label class="field-label">
                Market
                <span matTooltip="Select market/countries for this user" style="
                    background-image: url('/assets/images/Vector.svg');
                    background-repeat: no-repeat;
                    background-size: auto;
                    background-position: center;
                    padding: 10px;
                  "></span>
              </label>

              <div class="custom-market-dropdown-wrapper" style="position: relative;">
                <div class="custom-market-trigger-box" (click)="toggleCountryDropdown($event)">
                  <div class="market-chips-container" *ngIf="addEditUserForm.controls.countryId.value?.length > 0">
                    <span *ngFor="let id of addEditUserForm.controls.countryId.value" class="market-chip">
                      {{ getCountryName(id) }}
                      <span class="chip-remove material-icons"
                        (click)="removeCountry(id, $event)">indeterminate_check_box</span>
                    </span>
                  </div>
                  <span class="placeholder-text" *ngIf="
                      !addEditUserForm.controls.countryId.value ||
                      addEditUserForm.controls.countryId.value.length === 0
                    ">
                    Select Market
                  </span>
                  <span class="dropdown-chevron">
                    <img src="/assets/images/down-arrow 1.svg" height="16px" width="16px" [style.transform]="
                        isCountryDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'
                      " [style.transition]="'transform 0.3s ease'" />
                  </span>
                </div>

                <!-- Dropdown Content Options Panel -->
                <div class="custom-market-dropdown-content" *ngIf="isCountryDropdownOpen">
                  <div class="dropdown-search-box">
                    <mat-icon class="search-icon">search</mat-icon>
                    <input type="text" placeholder="Search country" [(ngModel)]="countrySearchText"
                      [ngModelOptions]="{ standalone: true }" />
                  </div>

                  <div class="dropdown-options-list">
                    <div *ngFor="let c of getFilteredCountries()" class="dropdown-option-item"
                      (click)="toggleSelectCountry(c.id, $event)">
                      <mat-checkbox [checked]="isCountrySelected(c.id)" style="pointer-events: none;">
                        {{ c.name }}
                      </mat-checkbox>
                    </div>

                    <div class="no-results-found" *ngIf="getFilteredCountries().length === 0">
                      No countries found
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- User Role -->
            <div class="col-md-6 form-group-col">
              <label class="field-label">
                User Role
                <span matTooltip="Select user role" style="
                    background-image: url('/assets/images/Vector.svg');
                    background-repeat: no-repeat;
                    background-size: auto;
                    background-position: center;
                    padding: 10px;
                  "></span>
              </label>

              <div class="custom-role-dropdown-wrapper" style="position: relative;">
                <div class="custom-market-trigger-box" (click)="toggleRoleDropdown($event)">
                  <span [ngStyle]="{
                      color: addEditUserForm.controls.userRoleId.value ? '#334155' : '#94a3b8',
                      fontSize: '14px',
                      fontWeight: addEditUserForm.controls.userRoleId.value ? '500' : 'normal'
                    }">
                    {{ getUserRoleName(addEditUserForm.controls.userRoleId.value) }}
                  </span>
                  <span class="dropdown-chevron">
                    <img src="/assets/images/down-arrow 1.svg" height="16px" width="16px" [style.transform]="
                        isRoleDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'
                      " [style.transition]="'transform 0.3s ease'" />
                  </span>
                </div>

                <!-- Dropdown Options Panel -->
                <div class="custom-market-dropdown-content" *ngIf="isRoleDropdownOpen">
                  <div class="dropdown-options-list">
                    <div *ngFor="let item of userRoles" class="dropdown-option-item"
                      [class.selected-option]="addEditUserForm.controls.userRoleId.value == item.id"
                      (click)="selectRole(item.id, $event)">
                      {{ item.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Allow Email Notifications -->
            <div class="col-md-6 form-group-col">
              <label class="field-label">
                Allow Email Notifications for this User
                <span matTooltip="Enable email notification alerts for this user" style="
                    background-image: url('/assets/images/Vector.svg');
                    background-repeat: no-repeat;
                    background-size: auto;
                    background-position: center;
                    padding: 10px;
                  "></span>
              </label>

              <div class="notification-pill-container">
                <button type="button" class="notification-pill-btn" [class.selected]="
                    addEditUserForm.controls.isNotificationEnable.value === true
                  " (click)="setNotificationEnable(true)">
                  <mat-icon class="radio-icon">
                    {{
                    addEditUserForm.controls.isNotificationEnable.value === true
                    ? "check_circle"
                    : "radio_button_unchecked"
                    }}
                  </mat-icon>
                  Yes, Allow
                </button>

                <button type="button" class="notification-pill-btn" [class.selected]="
                    addEditUserForm.controls.isNotificationEnable.value === false
                  " (click)="setNotificationEnable(false)">
                  <mat-icon class="radio-icon">
                    {{
                    addEditUserForm.controls.isNotificationEnable.value === false
                    ? "check_circle"
                    : "radio_button_unchecked"
                    }}
                  </mat-icon>
                  No
                </button>
              </div>
            </div>

            <!-- AOWGroup (if AOWAdmin) -->
            <div class="col-md-6 form-group-col" *ngIf="
                addEditUserForm['controls'].userRoleId.value ==
                userRoleEnum.AOWAdmin
              ">
              <label class="field-label">
                AOWGroup
                <span matTooltip="Select AOW Group" style="
                    background-image: url('/assets/images/Vector.svg');
                    background-repeat: no-repeat;
                    background-size: auto;
                    background-position: center;
                    padding: 10px;
                  "></span>
              </label>

              <div class="custom-aow-dropdown-wrapper" style="position: relative;">
                <div class="custom-market-trigger-box" (click)="toggleAowDropdown($event)">
                  <span [ngStyle]="{
                      color: addEditUserForm.controls.aowGroupId.value ? '#334155' : '#94a3b8',
                      fontSize: '14px',
                      fontWeight: addEditUserForm.controls.aowGroupId.value ? '500' : 'normal'
                    }">
                    {{ getAowGroupName(addEditUserForm.controls.aowGroupId.value) }}
                  </span>
                  <span class="dropdown-chevron">
                    <img src="/assets/images/down-arrow 1.svg" height="16px" width="16px" [style.transform]="
                        isAowDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'
                      " [style.transition]="'transform 0.3s ease'" />
                  </span>
                </div>

                <!-- Dropdown Options Panel -->
                <div class="custom-market-dropdown-content" *ngIf="isAowDropdownOpen">
                  <div class="dropdown-options-list">
                    <div *ngFor="let item of aowGroups" class="dropdown-option-item"
                      [class.selected-option]="addEditUserForm.controls.aowGroupId.value == item.id"
                      (click)="selectAowGroup(item.id, $event)">
                      {{ item.groupName }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>

        <!-- Action Buttons -->
        <div class="card-footer-actions">
          <button type="button" class="btn-cancel-outline" (click)="onCancelClick()">
            Cancel
          </button>
          <button type="submit" class="btn-save-gold" (click)="onSaveUser()" [disabled]="addEditUserForm.invalid">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<app-mcd-loader class="mcd-page-loader" *ngIf="loading"></app-mcd-loader>